
import React from "react";
import { IconButton, Modal } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import MatterDetails from "./MatterDetails";
import Div from "@jumbo/shared/Div/Div";

const MatterDetailsModal = ({ open, handleClose, id, handleSelectedRow,isXfa }) => {
  return (
    <Modal
      open={open}
      onClose={(handleClose, handleSelectedRow)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Div
        sx={{
          justifyContent: "flex-start !important",
        }}
        className="customize-modal preview-form"
      >
        <div className="modal-head">
          <h2>&nbsp;</h2>
          <IconButton
            className="close-modal-btn p-0"
            onClick={() => {
              handleClose();
            }}
          >
            <HighlightOffIcon />
          </IconButton>
        </div>
        <div className="modal-body-content">
          {/* Pass the 'id' prop to the MatterDetails component */}
          <MatterDetails
            id={id}
            isXfa={isXfa}
            handleClose={handleClose}
          />
        </div>
      </Div>
    </Modal>
  );
};

export default MatterDetailsModal;
